import GetTenantRequestModelBase from '../_generated/modelBases/get-tenant-request-model-base';

export default class GetTenantRequestModel extends GetTenantRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
